"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_EXPIRED_ERROR = exports.GENERIC_NETWORK_ERROR = void 0;
var axios_1 = __importDefault(require("axios"));
var networkStatusSlice_1 = require("../networkStatusSlice/networkStatusSlice");
var CancellableRequestTracker_1 = require("../CancellableRequestTracker");
var NetworkTypes_1 = require("../NetworkTypes");
var utils_1 = require("../../utils");
exports.GENERIC_NETWORK_ERROR = 'Error de conexión';
exports.SESSION_EXPIRED_ERROR = 'Ha expirado su sesión';
/**
 * Will check if a fatal fail needs to be applied, and will throw the appropiated
 * error.
 *
 * @param responseData - The response object
 * @param customFail - The custom fail logic provided to processRequest
 */
function lookForRetryFail(responseData, customFail, customFailSideEffect) {
    if (typeof customFail !== 'undefined' && customFail(responseData)) {
        if (customFailSideEffect) {
            customFailSideEffect(responseData);
        }
        throw new Error('custom fail logic');
    }
}
/**
 * Check if there exists a custom retry fail, and will throw the appropiated error based
 * on the current attempt.
 *
 * @param responseData - The response object
 * @param attempt - The current attempt offset
 * @param fatalFailTolerance - The offset tolerance before the fail is actually considered
 * @param customFatalFail - Custom fail logic
 */
function lookForRetryFatalFail(responseData, attempt, fatalFailTolerance, customFatalFail) {
    if (typeof customFatalFail !== 'undefined' && customFatalFail(responseData)) {
        if (attempt >= fatalFailTolerance) {
            throw new NetworkTypes_1.FatalRetryError(responseData);
        }
        else {
            throw new Error('fatal fail catch');
        }
    }
}
/**
 * Will return true if the provided error must be thrown immediatly instead of it being
 * processed.
 *
 * @param e - The error generated by the request
 */
function mustForwardError(e) {
    return axios_1.default.isCancel(e) || e.isFatalRetry;
}
/**
 * Will try to generate an error message based on the provided logic. Will return an empty
 * string if no custom error message can be created.
 *
 * @param e - The error generated by the request
 * @param customErrorMessage - the custom error message generation
 */
function makeErrorMessageString(e, customErrorMessage) {
    return customErrorMessage ? customErrorMessage(e) : '';
}
function notifyErrorToStore(_a) {
    var customErrorMessage = _a.customErrorMessage, error = _a.error, supressError = _a.supressError, reduxStore = _a.reduxStore;
    if (reduxStore && !supressError) {
        if (error && error.response && error.response.status === 401) {
            reduxStore.dispatch(networkStatusSlice_1.updateLastNetworkErrorMessage(exports.SESSION_EXPIRED_ERROR));
        }
        else {
            reduxStore.dispatch(networkStatusSlice_1.updateLastNetworkErrorMessage(customErrorMessage || exports.GENERIC_NETWORK_ERROR));
        }
    }
}
/**
 * Performs a network request, and handles both success and error cases.
 *
 * Note: Will throw an exception on network failure, call it inside a try-catch block. A failed request
 * will throw one of the following:
 * - If cancelled, invoking `axios.isCancel` with the thrown execption will return true.
 * - If a fatal retry error is detected, will throw FatalRetryError.
 * - Throws ResponseError as a fallback, with optional input error data.
 */
function processRequest(_a) {
    var method = _a.method, url = _a.url, client = _a.client, cancelTokenSource = _a.cancelTokenSource, _b = _a.uniqueIdentifier, uniqueIdentifier = _b === void 0 ? '' : _b, _c = _a.data, data = _c === void 0 ? {} : _c, _d = _a.headers, headers = _d === void 0 ? {} : _d, customErrorMessage = _a.customErrorMessage, _e = _a.supressError, supressError = _e === void 0 ? false : _e, reduxStore = _a.reduxStore, _f = _a.retryProps, retryProps = _f === void 0 ? { maxAttempts: 1 } : _f;
    return __awaiter(this, void 0, void 0, function () {
        var maxAttempts, customFail, customFatalFail, _g, fatalFailTolerance, _h, attempt, customFailSideEffect, usedCancelToken, response, e_1, errorAxios, errorResponse, errorData, responseError;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    maxAttempts = retryProps.maxAttempts, customFail = retryProps.customFail, customFatalFail = retryProps.customFatalFail, _g = retryProps.fatalFailTolerance, fatalFailTolerance = _g === void 0 ? 1 : _g, _h = retryProps.attempt, attempt = _h === void 0 ? 1 : _h, customFailSideEffect = retryProps.customFailSideEffect;
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 3, , 6]);
                    usedCancelToken = axios_1.default.CancelToken.source();
                    if (cancelTokenSource) {
                        usedCancelToken = cancelTokenSource;
                    }
                    /** This is what makes the request cancellable */
                    CancellableRequestTracker_1.uniqueRequest(uniqueIdentifier, usedCancelToken);
                    return [4 /*yield*/, client({
                            url: url,
                            data: data,
                            method: method,
                            headers: headers,
                            cancelToken: usedCancelToken.token,
                        })];
                case 2:
                    response = _j.sent();
                    /** Look for retry failures */
                    lookForRetryFatalFail(response.data, attempt, fatalFailTolerance, customFatalFail);
                    lookForRetryFail(response.data, customFail, customFailSideEffect);
                    /** Notify unique request finished */
                    CancellableRequestTracker_1.uniqueRequestFinished(uniqueIdentifier);
                    return [2 /*return*/, response.data];
                case 3:
                    e_1 = _j.sent();
                    CancellableRequestTracker_1.uniqueRequestFinished(uniqueIdentifier);
                    /** Forward both cancellation and fatal retry errors */
                    if (mustForwardError(e_1)) {
                        throw e_1;
                    }
                    errorAxios = e_1;
                    if (!(attempt < maxAttempts)) return [3 /*break*/, 5];
                    /**
                     * Also, wait before trying to execute the request again. Each attempt will wait
                     * for a longer time than the one before it, according to the Fibonacci sequence
                     */
                    return [4 /*yield*/, utils_1.timeout(utils_1.getFibbonacciSequence(attempt) * 1000)];
                case 4:
                    /**
                     * Also, wait before trying to execute the request again. Each attempt will wait
                     * for a longer time than the one before it, according to the Fibonacci sequence
                     */
                    _j.sent();
                    return [2 /*return*/, processRequest({
                            method: method,
                            url: url,
                            client: client,
                            cancelTokenSource: cancelTokenSource,
                            uniqueIdentifier: uniqueIdentifier,
                            data: data,
                            headers: headers,
                            customErrorMessage: customErrorMessage,
                            supressError: supressError,
                            reduxStore: reduxStore,
                            retryProps: __assign(__assign({}, retryProps), { attempt: attempt + 1 }),
                        })];
                case 5:
                    notifyErrorToStore({
                        customErrorMessage: makeErrorMessageString(errorAxios, customErrorMessage),
                        error: errorAxios,
                        reduxStore: reduxStore,
                        supressError: supressError,
                    });
                    /** The final error treating logic */
                    if (e_1 && errorAxios.response) {
                        errorResponse = errorAxios.response;
                        errorData = errorResponse.data.data;
                        if (errorData && errorData.error) {
                            responseError = new NetworkTypes_1.ResponseError(errorData.error, errorData.inputErrors);
                            responseError.response = errorResponse;
                            throw responseError;
                        }
                        throw e_1;
                    }
                    else {
                        throw new NetworkTypes_1.ResponseError('Network Error');
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.default = processRequest;
//# sourceMappingURL=processRequest.js.map